import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import clsx from 'clsx'
import * as R from 'ramda'
import {
  PLACE_INVITATION_PENDING_REQUEST,
  PLACE_INVITATION_REMOVE_SUBSCRIPTION,
  PLACE_INVITATION_UNSUBSCRIBED,
  PLACE_INVITATION_ADDED,
  PLACE_INVITATION_ACCEPT_REQUEST,
  PLACE_INVITATION_ACCEPT_INVITATION,
  PLACE_INVITATION_PUBLIC_SUBSCRIBE,
} from 'app/configs/statusConfigs'
import { FormattedMessage } from 'react-intl'
import StatusChips from 'app/components/StatusChips'
import transformCrmFields from './crmFields'
import useStyles from './dialogStyles'
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined'
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close'
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import EditLocationOutlinedIcon from '@material-ui/icons/EditLocationOutlined'
import ContactMailOutlinedIcon from '@material-ui/icons/ContactMailOutlined'
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined'
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined'
import CakeIcon from '@material-ui/icons/Cake'
import SaveIcon from '@material-ui/icons/Save'
import LanguageIcon from '@material-ui/icons/Language'
import HelpIcon from '@material-ui/icons/Help'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import { useIntl } from 'react-intl'
import { getHumanizeDate } from 'commons/date'
import { withStyles } from '@material-ui/core/styles'
import { SUBSCRIBER_REJECT, SUBSCRIBER_APPROVE } from '../constants'
import appConfigs from 'app/configs/appConfigs'
import Tooltip from '@material-ui/core/Tooltip'
import { findNumbers } from 'libphonenumber-js'
import { AccessType } from 'app/auth/accessControlService'
import { useAccessControl } from 'app/auth/useAccessControl'
import AccessControl from 'app/auth/AccessControl'
import PersonAvatar from 'app/components/PersonAvatar'
import { getCountriesSuccess } from 'app/store/actions/loadCountries.actions'
import { getNationalitiesSuccess } from 'app/store/actions/loadNationalities.actions'
import Assets from 'app/configs/assetConfigs'
import { useAppName } from 'commons/usePartner'
import Notes from './Notes'
import ZoomAvatar from '../ZoomAvatar'
import effects from 'app/effects/effects'
import { IconButton } from '@material-ui/core'
import MessageAlert from 'app/components/MessageAlert'
import { openDialog } from 'app/auth/store/actions/createNotification.actions'
import { ACTION_NEW, GENERAL_DIALOG } from 'app/constants/compose'
import { TYPE_SUBSCRIBERS, VIA_ONE_ROSTER } from 'app/main/subscriber/constants'
import { Link } from '@material-ui/core'
import {
  CHANNEL_APP,
  CHANNEL_SMS,
  CHANNEL_EMAIL,
  CHANNEL_CALL,
} from 'app/constants/channel'
import { getStatePhysicalSuccess } from 'app/store/actions/loadStatePhysical.actions'
import { getStateMailingSuccess } from 'app/store/actions/loadStateMailing.actions'

const TYPE_LINK = 'link'
const TYPE_PHONE = 'phone'

export default React.memo((props) => {
  const {
    subscriber,
    approveOrReject,
    updateCrmFields,
    openOrCloseDetailsDialog,
    openOrCloseEditDetailsDialog,
    openMembershipCardListDialog,
  } = props

  const isSubscribed = R.includes(subscriber.lastInvitationStatus, [
    PLACE_INVITATION_ACCEPT_REQUEST,
    PLACE_INVITATION_ACCEPT_INVITATION,
    PLACE_INVITATION_PUBLIC_SUBSCRIBE,
  ])

  const [localState, setLocalState] = useState({
    isShowApprove:
      subscriber.lastInvitationStatus === PLACE_INVITATION_PENDING_REQUEST,
    isUnsubscribed:
      subscriber.lastInvitationStatus ===
        PLACE_INVITATION_REMOVE_SUBSCRIPTION ||
      subscriber.lastInvitationStatus === PLACE_INVITATION_UNSUBSCRIBED,
    isEditEmail: false,
    isDisplayEditEmailIcon:
      subscriber.lastInvitationStatus === PLACE_INVITATION_ADDED,
    subscriberEmail: subscriber.email,
  })
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const styleClass = useStyles()
  const countryList = useSelector(({ countries }) => countries.countryList)
  const statePhysicalList = useSelector(
    ({ statePhysical }) => statePhysical.statePhysicalList,
  )
  const stateMailingList = useSelector(
    ({ stateMailing }) => stateMailing.stateMailingList,
  )
  const crmFields = transformCrmFields(
    subscriber,
    countryList,
    statePhysicalList,
    stateMailingList,
  )
  let groups = crmFields.groups.groupList
  const { selectedPlace } = useSelector(({ auth }) => auth.user)
  const isDisplayCareCheck = selectedPlace.info.shouldSeeCarecheck
  const appName = useAppName()
  const crmPhysicalCountryId = R.path(
    ['crmInfo', 'physicalCountry'],
    subscriber,
  )
  const crmMailingCountryId = R.path(['crmInfo', 'mailingCountry'], subscriber)
  const { isGranted: isEditGranted } = useAccessControl([
    AccessType.SUBSCRIBER_UPDATE,
    AccessType.ADMINISTRATION,
  ])

  const channelType = R.compose(
    R.prop('channel'),
    R.find(R.prop('isSelected')),
    R.prop('receiveMethods'),
  )(subscriber)

  function hideApprove() {
    setLocalState({
      ...localState,
      isShowApprove: false,
    })
  }

  let getCountryCode = (phoneNumber) => {
    let numberInfo = findNumbers(phoneNumber)
    return numberInfo[0] ? numberInfo[0].country.toLowerCase() : ''
  }

  function setGroupRow(label, value, labelData, renderElemType) {
    let renderItem = <div className={styleClass.groupRowItemRS}>{value}</div>

    if (renderElemType === TYPE_LINK) {
      renderItem = value && (
        <Link
          target="_blank"
          href={value}
          className={clsx(
            styleClass.groupRowItemRS,
            styleClass.groupRowItemLink,
          )}
        >
          {value}
        </Link>
      )
    } else if (renderElemType === TYPE_PHONE && value) {
      let countryFlag = getCountryCode(value)
      renderItem = (
        <div
          className={clsx(
            styleClass.groupRowItemRSFlag,
            styleClass.groupRowItemFlag,
            'react-tel-input',
          )}
        >
          <div className={clsx('flag', countryFlag)} />
          {value}
        </div>
      )
    }

    return value ? (
      <div className={styleClass.groupRowItem}>
        <div className={styleClass.groupRowItemLS}>
          {formatMessage({ id: label }, labelData)}
        </div>

        {renderItem}
      </div>
    ) : (
      ''
    )
  }

  let isShowContactInfo =
    crmFields.email ||
    crmFields.secondaryEmail ||
    crmFields.fullPhoneNumber ||
    crmFields.automatedCallFullPhoneNumber ||
    crmFields.fullOtherMobileNumber ||
    crmFields.fullOtherPhoneNumber ||
    crmFields.fullOfficePhoneNumber ||
    crmFields.fullHomePhoneNumber ||
    crmFields.fullFaxNumber

  let isShowPhysical =
    crmFields.physicalCountry['name'] ||
    crmFields.physicalState['name'] ||
    crmFields.physicalCountryName ||
    crmFields.physicalStreetAddress1 ||
    crmFields.physicalStreetAddress2 ||
    crmFields.physicalCityName ||
    crmFields.physicalPostalCode

  let isShowMailing =
    crmFields.mailingCountry['name'] ||
    crmFields.mailingState['name'] ||
    crmFields.mailingCountryName ||
    crmFields.mailingStreetAddress1 ||
    crmFields.mailingStreetAddress2 ||
    crmFields.mailingCityName ||
    crmFields.mailingPostalCode

  let isShowEmployerInfo =
    crmFields.companyName || crmFields.jobTitle || crmFields.jobDepartment

  let isShowSocialInfo =
    crmFields.facebookProfile ||
    crmFields.twitterProfile ||
    crmFields.linkedinProfile ||
    crmFields.lineProfile

  const isNonEditable = subscriber?.via === VIA_ONE_ROSTER

  const handleEditEmail = () => {
    setLocalState({
      ...localState,
      isEditEmail: true,
    })
  }

  const handleSaveEmail = () => {
    setLocalState({
      ...localState,
      isEditEmail: false,
    })

    let obj = {
      ...subscriber.crmInfo,
      ...subscriber,
      email: localState.subscriberEmail,
    }
    delete obj.crmInfo
    delete obj.invitationsHistory
    delete obj.place
    if (obj.tags) {
      obj.tags = obj.tags.map((item) => item.id)
    }
    if (obj.physicalCountry) {
      obj.physicalCountryId = obj.physicalCountry.id
    }
    if (obj.mailingCountry) {
      obj.mailingCountryId = obj.mailingCountry.id
    }
    updateCrmFields(subscriber, obj)
  }

  const onChangeEmail = (e) => {
    setLocalState({
      ...localState,
      subscriberEmail: e.target.value,
    })
  }

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      borderRadius: 9,
      boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
      backgroundColor: '#ffffff',
      color: '#404040',
      maxWidth: 390,
      border: '1px solid #dadde9',
      fontSize: 14,
      padding: '18px 23px',
    },
  }))(Tooltip)

  let humanDate = useMemo(() => {
    return getHumanizeDate(subscriber.lastSeenDate)
  }, [subscriber.lastSeenDate])

  useEffect(() => {
    effects.apis.getCountries().then((countries) => {
      dispatch(getCountriesSuccess(countries.data))
    })

    effects.apis.getNationalities().then((nationalities) => {
      dispatch(getNationalitiesSuccess(nationalities.data))
    })

    effects.apis
      .getStatesByCountryId({ countryId: crmPhysicalCountryId })
      .then((states) => {
        dispatch(getStatePhysicalSuccess(states.data))
      })

    effects.apis
      .getStatesByCountryId({ countryId: crmMailingCountryId })
      .then((states) => {
        dispatch(getStateMailingSuccess(states.data))
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onOpenCreateNotificationDialog = () => {
    openOrCloseDetailsDialog()
    dispatch(
      openDialog({
        initialValues: {
          subscribers: [
            R.mergeRight(subscriber, {
              type: TYPE_SUBSCRIBERS,
              name: `${subscriber.firstName} ${subscriber.lastName}`,
            }),
          ],
        },
        onCreateSuccess: () => {
          dispatch(
            MessageAlert.showSuccess({
              message: formatMessage({
                id: 'createNotification.success.message',
              }),
            }),
          )
        },
        type: GENERAL_DIALOG,
        action: ACTION_NEW,
      }),
    )
  }

  const convertCountryCodeToName = (countryId) => {
    let currentCountry
    currentCountry =
      countryList.length > 0
        ? countryList.find((item) => item.id === Number(countryId))
        : null
    return currentCountry && `${currentCountry.name} (${currentCountry.code})`
  }

  const getSubscriberReceiveMethod = () => {
    if (channelType === CHANNEL_APP) {
      return formatMessage(
        { id: 'crm.form.notificationMethod.app' },
        { appName },
      )
    }

    if (channelType === CHANNEL_SMS) {
      return formatMessage({ id: 'crm.form.notificationMethod.sms' })
    }

    if (channelType === CHANNEL_EMAIL) {
      return formatMessage({ id: 'crm.form.notificationMethod.email' })
    }
    if (channelType === CHANNEL_CALL)
      return formatMessage({ id: 'message.credit.alert.dialog.automateCall' })
  }

  const getTopicList = (topicsArr) => {
    const topicList = topicsArr.map((el) => (
      <p key={el.id} style={{ paddingBottom: '1rem' }}>
        {el.name}
      </p>
    ))
    return <div className={styleClass.topicList}>{topicList}</div>
  }

  return (
    <Dialog
      maxWidth="md"
      fullWidth={true}
      className={styleClass.dialogWrapper}
      open={true}
    >
      <DialogTitle disableTypography={true} className={styleClass.titleColor}>
        <div className="flex justify-end text-white">
          <AccessControl
            accesses={[AccessType.NOTIFICATION_SEND, AccessType.ADMINISTRATION]}
          >
            {isSubscribed && (
              <IconButton
                onClick={() => {
                  onOpenCreateNotificationDialog()
                }}
                className="p-0 px-4 mx-2"
              >
                <img
                  className={styleClass.postIcon}
                  src={Assets.postIcon.white}
                  alt="PostIcon"
                />
              </IconButton>
            )}
          </AccessControl>

          {/* {appConfigs.isMembershipCardEnabled && !isNonEditable && (
            <CreditCardIcon
              className="cursor-pointer mr-4 text-white"
              onClick={() => openMembershipCardListDialog(subscriber)}
            />
          )} */}
          {isEditGranted && !isNonEditable && (
            <EditIcon
              className="cursor-pointer mr-4"
              onClick={openOrCloseEditDetailsDialog}
            />
          )}
          <CloseIcon
            className="cursor-pointer"
            onClick={openOrCloseDetailsDialog}
          />
        </div>
        <div className="flex justify-start">
          <ZoomAvatar src={subscriber.crmInfo.avatar}>
            <PersonAvatar
              placeHolder={subscriber.avatarCharacters}
              subId={subscriber.id}
              alt={subscriber.firstName}
              src={subscriber.crmInfo.avatar}
              className={styleClass.avatar}
            />
          </ZoomAvatar>
          <div className="w-full px-10 align-middle m-auto truncate">
            <div className={clsx(styleClass.nameStyle, 'truncate')}>
              <div className="space-x-4">
                <div className="inline-block">{crmFields.fullName}</div>
                <div className="inline-block">
                  <div className={styleClass.subscriberDetailsStatus}>
                    <StatusChips
                      isShadow={true}
                      status={subscriber.lastInvitationStatus}
                      isShowTooltip={true}
                    />
                  </div>
                </div>
              </div>
              <div className={styleClass.lastSeen}>
                {humanDate && (
                  <div>
                    {formatMessage(
                      { id: 'subscriber.lastSeen.label' },
                      {
                        formattedDate: humanDate,
                        dateCount: humanDate.split(',').length,
                      },
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={clsx('flex', styleClass.groupSection)}>
              {Object.keys(groups).map((keyName, index) => {
                return (
                  <Tooltip
                    key={index}
                    title={
                      <>
                        {groups[keyName].map((subGroup, index) => (
                          <p key={index}>{subGroup}</p>
                        ))}
                      </>
                    }
                  >
                    <div className={styleClass.groupBoxStyle}>
                      <p className="truncate">{keyName}</p>
                    </div>
                  </Tooltip>
                )
              })}
            </div>
          </div>
        </div>
      </DialogTitle>

      {localState.isShowApprove && (
        <div className={clsx(styleClass.sectionApprove, 'md:flex p-5')}>
          <div
            className={clsx(
              styleClass.sectionApproveTitle,
              'w-full p-5 text-center m-auto truncate',
            )}
          >
            <FormattedMessage
              id="dialog.sunscriber.waiting.approve"
              values={{
                firstName: crmFields.originalFirstName,
                lastName: crmFields.originalLastName,
              }}
            />
          </div>

          <div
            className={clsx(
              styleClass.sectionApproveActions,
              'w-full p-4 text-center',
            )}
          >
            <button
              className={clsx(
                styleClass.sectionApproveBtn,
                'w-full sm:w-2/6 m-4 p-5',
              )}
              onClick={() => {
                approveOrReject(SUBSCRIBER_APPROVE, subscriber.id, hideApprove)
              }}
            >
              {formatMessage({ id: 'crm.form.approve' })}
            </button>

            <button
              className={clsx(
                styleClass.sectionRejectBtn,
                'w-full sm:w-2/6 m-4 p-5',
              )}
              onClick={() => {
                approveOrReject(SUBSCRIBER_REJECT, subscriber.id, hideApprove)
              }}
            >
              {formatMessage({ id: 'rejectBtn' })}
            </button>
          </div>
        </div>
      )}

      <DialogContent className={styleClass.contentSection}>
        <div className={styleClass.contentSectionWrapper}>
          <div className={styleClass.subscriberDetails}>
            <div className={styleClass.subscriberDetailsWrapper}>
              <div
                className={clsx(styleClass.groupRowFirst, styleClass.groupRow)}
              >
                <div className={styleClass.groupRowIcon}>
                  <AccountCircleOutlinedIcon />
                </div>
                <div className={styleClass.groupRightWrapper}>
                  <div className={styleClass.groupRowTitle}>
                    {formatMessage({ id: 'privacyPolicy.title.content1' })}
                  </div>

                  <div className={styleClass.groupRowContent}>
                    {setGroupRow('crm.form.fullName', crmFields.fullName)}
                    {setGroupRow(
                      'crm.form.phoneticFullName',
                      crmFields.phoneticFullName,
                    )}
                    {setGroupRow('crm.form.prefix', crmFields.prefix)}
                    {setGroupRow('crm.form.suffix', crmFields.suffix)}
                    {setGroupRow('crm.form.formalTitle', crmFields.formalTitle)}
                    {setGroupRow('crm.form.nickname', crmFields.nickname)}
                    {setGroupRow(
                      'crm.form.shouldUserBeContacted',
                      crmFields.contactableText,
                      { user: crmFields.firstName },
                    )}
                    {setGroupRow('crm.form.dateOfBirth', crmFields.crmBirthday)}
                    {setGroupRow('crm.form.gender', crmFields.gender)}
                    {setGroupRow(
                      'subscriber.label.uniqueId',
                      crmFields.uniqueId,
                    )}
                    {setGroupRow(
                      'crm.form.placeOfBirth',
                      crmFields.placeOfBirth,
                    )}
                    {setGroupRow('crm.form.nationality', crmFields.nationality)}
                    {setGroupRow(
                      'crm.form.passportExpiresAt',
                      crmFields.passportExpiresAt,
                    )}
                    {setGroupRow('crm.form.passportId', crmFields.passportId)}
                    {setGroupRow(
                      'crm.form.passportCountryCode',
                      convertCountryCodeToName(crmFields.passportCountryCode),
                    )}
                    {isDisplayCareCheck &&
                      setGroupRow(
                        'crm.form.careCheckId',
                        crmFields.originalCareCheckId,
                      )}
                    {setGroupRow(
                      'crm.form.notificationMethod',
                      getSubscriberReceiveMethod(),
                    )}
                  </div>
                  {!!crmFields.topics.length &&
                    setGroupRow(
                      'notifications.topics.label',
                      getTopicList(crmFields.topics),
                    )}
                </div>
              </div>

              {isShowContactInfo && (
                <div
                  className={clsx(
                    styleClass.groupRowFirst,
                    styleClass.groupRow,
                  )}
                >
                  <div className={styleClass.groupRowIcon}>
                    <PersonOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRightWrapper}>
                    <div className={styleClass.groupRowTitle}>
                      {formatMessage({ id: 'profile.contactDetail.label' })}
                    </div>

                    <div className={styleClass.groupRowContent}>
                      {setGroupRow('crm.form.email', crmFields.email)}
                      {setGroupRow(
                        'crm.form.secondaryEmail',
                        crmFields.secondaryEmail,
                      )}
                      {setGroupRow(
                        'crm.form.primaryPhone',
                        crmFields.fullPhoneNumber,
                        {},
                        TYPE_PHONE,
                      )}
                      {setGroupRow(
                        'message.credit.alert.dialog.automateCall',
                        crmFields.automatedCallFullPhoneNumber,
                        {},
                        TYPE_PHONE,
                      )}
                      {setGroupRow(
                        'crm.form.otherMobileNumber',
                        crmFields.fullOtherMobileNumber,
                        {},
                        TYPE_PHONE,
                      )}
                      {setGroupRow(
                        'crm.form.otherPhoneNumber',
                        crmFields.fullOtherPhoneNumber,
                        {},
                        TYPE_PHONE,
                      )}
                      {setGroupRow(
                        'crm.form.officePhoneNumber',
                        crmFields.fullOfficePhoneNumber,
                        {},
                        TYPE_PHONE,
                      )}
                      {setGroupRow(
                        'crm.form.homePhoneNumber',
                        crmFields.fullHomePhoneNumber,
                        {},
                        TYPE_PHONE,
                      )}
                      {setGroupRow(
                        'crm.form.faxNumber',
                        crmFields.fullFaxNumber,
                        {},
                        TYPE_PHONE,
                      )}
                    </div>
                  </div>
                </div>
              )}

              {isShowPhysical && (
                <div
                  className={clsx(
                    styleClass.groupRowFirst,
                    styleClass.groupRow,
                  )}
                >
                  <div className={styleClass.groupRowIcon}>
                    <EditLocationOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRightWrapper}>
                    <div className={styleClass.groupRowTitle}>
                      {formatMessage({
                        id: 'crm.profile.contentName.physicalAddress',
                      })}
                    </div>

                    <div className={styleClass.groupRowContent}>
                      {setGroupRow(
                        'crm.form.physicalCountry',
                        crmFields.physicalCountry['name'],
                      )}
                      {setGroupRow(
                        'crm.form.physicalStreetAddress',
                        crmFields.physicalStreetAddress1,
                      )}
                      {setGroupRow(
                        'crm.form.physicalStreetAddressLine2',
                        crmFields.physicalStreetAddress2,
                      )}
                      {setGroupRow(
                        'crm.form.physicalCityName',
                        crmFields.physicalCityName,
                      )}
                      {setGroupRow(
                        `crm.form.stateType.${crmFields.physicalCountry['regionType']}`,
                        crmFields.physicalState['name'],
                      )}
                      {setGroupRow(
                        'crm.form.physicalPostalCode',
                        crmFields.physicalPostalCode,
                      )}
                    </div>
                  </div>
                </div>
              )}

              {isShowMailing && (
                <div
                  className={clsx(
                    styleClass.groupRowFirst,
                    styleClass.groupRow,
                  )}
                >
                  <div className={styleClass.groupRowIcon}>
                    <ContactMailOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRightWrapper}>
                    <div className={styleClass.groupRowTitle}>
                      {formatMessage({ id: 'crm.form.mailingStreetAddress' })}
                    </div>

                    <div className={styleClass.groupRowContent}>
                      {setGroupRow(
                        'crm.form.mailingCountry',
                        crmFields.mailingCountry['name'],
                      )}
                      {setGroupRow(
                        'crm.form.mailingStreetAddress',
                        crmFields.mailingStreetAddress1,
                      )}
                      {setGroupRow(
                        'crm.form.mailingStreetAddressLine2',
                        crmFields.mailingStreetAddress2,
                      )}
                      {setGroupRow(
                        'crm.form.mailingCityName',
                        crmFields.mailingCityName,
                      )}
                      {setGroupRow(
                        `crm.form.stateType.${crmFields.mailingCountry['regionType']}`,
                        crmFields.mailingState['name'],
                      )}
                      {setGroupRow(
                        'crm.form.mailingPostalCode',
                        crmFields.mailingPostalCode,
                      )}
                    </div>
                  </div>
                </div>
              )}

              {isShowEmployerInfo && (
                <div
                  className={clsx(
                    styleClass.groupRowFirst,
                    styleClass.groupRow,
                  )}
                >
                  <div className={styleClass.groupRowIcon}>
                    <WorkOutlineOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRightWrapper}>
                    <div className={styleClass.groupRowTitle}>
                      {formatMessage({ id: 'crm.form.employerInformation' })}
                    </div>

                    <div className={styleClass.groupRowContent}>
                      {setGroupRow(
                        'crm.form.companyName',
                        crmFields.companyName,
                      )}
                      {setGroupRow('crm.form.jobTitle', crmFields.jobTitle)}
                      {setGroupRow(
                        'crm.form.jobDepartment',
                        crmFields.jobDepartment,
                      )}
                    </div>
                  </div>
                </div>
              )}

              {isShowSocialInfo && (
                <div
                  className={clsx(
                    styleClass.groupRowFirst,
                    styleClass.groupRow,
                  )}
                >
                  <div className={styleClass.groupRowIcon}>
                    <ShareOutlinedIcon />
                  </div>
                  <div className={styleClass.groupRightWrapper}>
                    <div className={styleClass.groupRowTitle}>
                      {formatMessage({ id: 'crm.form.socialInformation' })}
                    </div>

                    <div className={styleClass.groupRowContent}>
                      {setGroupRow(
                        'crm.form.facebookProfile',
                        crmFields.facebookProfile,
                        {},
                        TYPE_LINK,
                      )}
                      {setGroupRow(
                        'crm.form.twitterProfile',
                        crmFields.twitterProfile,
                        {},
                        TYPE_LINK,
                      )}
                      {setGroupRow(
                        'crm.form.linkedinProfile',
                        crmFields.linkedinProfile,
                        {},
                        TYPE_LINK,
                      )}
                      {setGroupRow(
                        'crm.form.lineProfile',
                        crmFields.lineProfile,
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <Notes isEditGranted={isEditGranted} subscriber={subscriber} />

          {!localState.isUnsubscribed && (
            <div className={styleClass.accountDetails}>
              <div className={styleClass.subscriberDetailsHead}>
                <div className={styleClass.subscriberDetailsTitle}>
                  <div>
                    {formatMessage(
                      { id: 'crm.form.accountDetails' },
                      { appName },
                    )}
                  </div>
                </div>

                <div className={styleClass.subscriberDetailsHeadRightSide}>
                  <div className={styleClass.subscriberDetailsHelp}>
                    <HtmlTooltip
                      placement="bottom-end"
                      title={<>{formatMessage({ id: 'crm.help.text' })}</>}
                    >
                      <HelpIcon />
                    </HtmlTooltip>
                    <span>{formatMessage({ id: 'crm.form.info' })}</span>
                  </div>
                </div>
              </div>

              <div className={styleClass.subscriberDetailsWrapper}>
                <div className={styleClass.subscriberDetailsProfile}>
                  <ZoomAvatar srcProfileMobile={subscriber.avatar}>
                    <PersonAvatar
                      subId={subscriber.id}
                      alt={subscriber.firstName}
                      src={subscriber.avatar}
                      className={styleClass.avatarMobileIcon}
                    />
                  </ZoomAvatar>

                  <span className={styleClass.itemColOne}>
                    {`${crmFields.originalFirstName} ${crmFields.originalLastName}`}
                  </span>
                </div>

                {subscriber.email && (
                  <div className={styleClass.subscriberDetailsItem}>
                    <EmailOutlinedIcon />
                    {localState.isEditEmail ? (
                      <>
                        <span className={styleClass.itemColOne}>
                          <input
                            type="text"
                            onChange={onChangeEmail}
                            value={localState.subscriberEmail}
                          />
                        </span>
                        <span className={styleClass.itemColEditEmail}>
                          <SaveIcon onClick={handleSaveEmail} />
                        </span>
                      </>
                    ) : (
                      <>
                        <a
                          href={`mailto:${localState.subscriberEmail}`}
                          className={clsx(
                            styleClass.itemColLink,
                            styleClass.itemColOne,
                          )}
                        >
                          {localState.subscriberEmail}
                        </a>
                        {localState.isDisplayEditEmailIcon && (
                          <span className={styleClass.itemColEditEmail}>
                            <EditIcon onClick={handleEditEmail} />
                          </span>
                        )}
                      </>
                    )}
                  </div>
                )}

                {subscriber.countryCode && (
                  <div className={styleClass.subscriberDetailsItem}>
                    <PhoneOutlinedIcon />
                    <a
                      href={`tel:${subscriber.countryCode} ${subscriber.phoneNumber}`}
                      className={clsx(
                        styleClass.itemColLink,
                        styleClass.itemColThree,
                      )}
                    >
                      {`${subscriber.countryCode} ${subscriber.phoneNumber}`}
                    </a>
                    <span className={styleClass.itemColFour}>
                      {formatMessage({ id: 'crm.form.mobile' })}
                    </span>
                  </div>
                )}

                {crmFields.birthday && (
                  <div className={styleClass.subscriberDetailsItem}>
                    <CakeIcon />
                    <span className={styleClass.itemColOne}>
                      {`${crmFields.birthday}`}
                    </span>
                  </div>
                )}

                {subscriber.language && subscriber.language.name && (
                  <div className={styleClass.subscriberDetailsItem}>
                    <LanguageIcon />
                    <span className={styleClass.itemColOne}>
                      {`${subscriber.language.name}`}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
})
